export const FETCH_RATE_INITIATED = 'FETCH_RATE_INITIATED';
export const FETCH_RATE_SUCCEEDED = 'FETCH_RATE_SUCCEEDED';
export const FETCH_RATE_FAILED = 'FETCH_RATE_FAILED';
